export enum UnitTypeEnum {
    VIDEO='video',
    AUDIO='audio',
    SCORM='scorm',
    DOCUMENT='document',
}
